module.exports = __webpack_public_path__ + "img/cegep-outaouais.5423d81b.webp";